import React, { useContext } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';

import TagPage from '../TagPage/TagPage';

import './PopularPages.scss';
import layoutContext from '../../layoutContext';
import { TEMPLATE_TOKENS } from '../../../constants/Languages';

const PopularPages = () => {
  const { cult } = useContext(layoutContext);
  return (
    <StaticQuery
      query={graphql`
        query {
          pages: allMarkdownRemark(
            sort: { fields: [frontmatter___date], order: DESC }
            filter: { fileAbsolutePath: { regex: "/content/" } }
          ) {
            totalCount
            edges {
              node {
                frontmatter {
                  headLine
                  path
                  category
                  lang
                }
              }
            }
          }
        }
      `}
      render={data => {
        const { microcreditParticipants } = TEMPLATE_TOKENS[cult];
        const { pages } = data;
        const { edges } = pages;

        const popularPagesArr = edges.reduce((
          pages,
          { node: { frontmatter: { headLine, path, category, lang } } }
        ) => {
          if (lang === cult && category === 'popular') {
            pages.push({ headLine, path });
          }
          return pages;
        }, []);

        popularPagesArr.push({
          headLine: microcreditParticipants,
          path: `${cult === 'ru' ? '' : '/uk'}/company-allukraine/`
        });

        return (
          <div className='tag-pages-container'>
            <div className='tag-pages'>
              {popularPagesArr.map(({ headLine, path }) => (
                <TagPage
                  key={path} path={path}
                  headLine={headLine}
                />
              ))}
            </div>
          </div>
        );
      }}
    />
  );
};

export default PopularPages;

PopularPages.propTypes = {
  stocks: PropTypes.bool,
  news: PropTypes.bool,
  articles: PropTypes.bool,
};
